<template>
	<v-card class="mb-1">
		<v-card-title>
      {{topic.name_pt}}
			<v-spacer></v-spacer>
			<v-btn class="ml-3" icon @click="showEdit = true">
				<v-icon color="primary">mdi-pencil</v-icon>
			</v-btn>
			<v-btn class="ml-1" icon @click="showDeleteTopic = true" disabled>
				<v-icon color="primary">mdi-delete</v-icon>
				<DeleteConfirmationDialog v-model="showDeleteTopic" item="topic" @delete="deleteTopic" />
			</v-btn>
		</v-card-title>
		<v-dialog v-model="showEdit" max-width="70%" scrollable>
			<v-card>
				<v-card-title class="title primary--text mb-2 secondary">
					<translate>Edit</translate>
				</v-card-title>
				<v-card-text class="pt-2">
					<v-form ref="topicForm">
						<v-row no-gutters>
              <v-col cols="12">
								<v-text-field
									:rules="[required]"
									v-model="topic.name_pt"
									:label="$gettext('Name') + ' PT'"
									outlined
								></v-text-field>
							</v-col>
              <v-col cols="12">
								<v-text-field
									:rules="[required]"
									v-model="topic.name_en"
									:label="$gettext('Name') + ' EN'"
									outlined
								></v-text-field>
							</v-col>
              <v-col cols="12">
								<v-text-field
									:rules="[required]"
									v-model="topic.name_es"
									:label="$gettext('Name') + ' ES'"
									outlined
								></v-text-field>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-btn color="primary darken-1" text @click="showEdit = false">
						<translate key="close">Close</translate>
					</v-btn>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="editTopic">
						<translate key="save">Save</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import DeleteConfirmationDialog from "@/components/DeleteConfirmationDialog.vue";
import axios from "axios";

export default {
  name: "Topic",
  props: ["topic"],
  components: {
		DeleteConfirmationDialog
  },
  data: () => ({
    showEdit: false,
		showDeleteTopic: false
  }),
  computed: {
		required() {
			return value => !!value || this.$gettext("Required.");
		}
  },
  methods: {
    editTopic() {
      if (this.$refs.topicForm.validate()) {
        const form = new FormData();
        form.append("name_pt", this.topic.name_pt);
        form.append("name_en", this.topic.name_en);
        form.append("name_es", this.topic.name_es);
				axios
					.post("/admin/question-answers-topics/" + this.topic.id + "/edit", form)
					.then(response => {
						console.log(response.data);
						if (response.data.result == "ok") {
              this.$emit("edit-topic", response.data.topic);
							this.showEdit = false;
						}
					})
					.catch(error => console.log(error));
			}
    },
    deleteTopic() {
      axios
				.post("/admin/question-answers-topics/" + this.topic.id + "/delete")
				.then(response => {
					console.log(response.data);
					if (response.data.result == "deleted") {
            this.$emit("delete-topic", this.topic);
            this.showDeleteTopic = false;
          }
					else this.showError = true;
				})
				.catch(error => console.log(error));
    }
  }
}
</script>